// @flow
import React from 'react';

import Visa from 'assets/images/payment-methods/visa.png';
import AmericanExpress from 'assets/images/payment-methods/american-express.png';
import DinersClub from 'assets/images/payment-methods/diners-club.png';
import Discover from 'assets/images/payment-methods/discover.png';
import Jcb from 'assets/images/payment-methods/jcb.png';
import Mastercard from 'assets/images/payment-methods/mastercard.png';
import UnionPay from 'assets/images/payment-methods/union-pay.png';

import Layout from 'components/shared/layout';
import { SUBMIT_INFO } from 'constants/payer/charge';

import {
  CreditCardLogo,
  CreditCardLastFour,
  PaymentMethodDetails,
  ReplaceCard,
  SubmitInfoCopy,
} from './styles';

const getCreditCardLogoUrl = cardProvider => {
  const cardProviderMap = {
    visa: Visa,
    mastercard: Mastercard,
    discover: Discover,
    jcb: Jcb,
    unionpay: UnionPay,
    'american express': AmericanExpress,
    'diners club': DinersClub,
  };

  const result = cardProviderMap[cardProvider.toLowerCase()];

  return result;
};

const CreditCardDetailsForm = ({ paymentMethod = { attributes: {} }, onClickReplace }: any) => {
  const {
    attributes: { brand, last4 },
  } = paymentMethod;

  return (
    <Layout>
      <SubmitInfoCopy>{SUBMIT_INFO.copy}</SubmitInfoCopy>

      {last4 && brand && (
        <PaymentMethodDetails>
          <div>
            <CreditCardLogo src={getCreditCardLogoUrl(brand)} alt={`${brand} logo`} />

            <CreditCardLastFour> -{last4} </CreditCardLastFour>
          </div>
          <ReplaceCard onClick={onClickReplace}>Replace card</ReplaceCard>
        </PaymentMethodDetails>
      )}
    </Layout>
  );
};

export default CreditCardDetailsForm;



// WEBPACK FOOTER //
// ./src/components/payer/credit-card-details-form/index.js